import { render } from "./MovesModal.vue?vue&type=template&id=b44b499c&scoped=true"
import script from "./MovesModal.vue?vue&type=script&lang=js"
export * from "./MovesModal.vue?vue&type=script&lang=js"

import "./MovesModal.vue?vue&type=style&index=0&id=b44b499c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44b499c"]])

export default __exports__